/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Button, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Link, useHistory } from 'react-router-dom';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { InstitutionalTableHead } from './TableHead';
import {
  getInstitutionalClaimsDiscrepancyResultGrid,
  getReferenceDataInstitutionalClaims,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { getProviderIdTypeDetails } from '../../../Display/Provider/store/action';
import { navigateToProvider } from '../../../Display/Claim/store/action';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function DispInstitutionalClaim() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [resultList, setResultList] = React.useState([]);
  const [referenceDataList, setReferenceDataList] = React.useState({});
  const {
    isLoading,
    rebateProgramValue,
    fromDateValue,
    toDateValue,
    searchResult,
    rebateProgramName,
    selectedPlanType,
    claimAuditSelected,
    claimCategorySelected,
    referenceData,
  } = useSelector((state) => state?.sharedState?.InstitutionalClaimsReducer);

  const dateRange = {
    fromDate: fromDateValue,
    toDate: toDateValue === '' ? fromDateValue : toDateValue,
  };
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  React.useEffect(() => {
    setResultList(searchResult);
  }, [searchResult]);

  // API call reference Data
  React.useEffect(() => {
    dispatch(
      getReferenceDataInstitutionalClaims({
        codeDomainList: ['PROVIDER_ID_TYPE_CD'],
      })
    );
  }, []);

  React.useEffect(() => {
    setReferenceDataList(referenceData);
  }, [referenceData]);

  // To give the code value to the provider ID Type column
  React.useEffect(() => {
    if (
      searchResult?.length > 0 &&
      referenceData?.PROVIDER_ID_TYPE_CD?.length > 0
    ) {
      const temp = {};
      const refData = referenceData?.PROVIDER_ID_TYPE_CD;
      for (let i = 0; i < refData?.length; i++) {
        temp[refData[i].codeValueID.codeValue] = refData[i].shortDescription;
      }

      const data = searchResult?.map((item) => {
        return {
          ...item,
          providerIdTypeCd: temp[item.providerIdTypeCd],
        };
      });
      setResultList(data);
    }
  }, [searchResult, referenceData]);

  // Go to Provider Redirection API call

  const goToProvider = async (cellInfo, data) => {
    const payload = {
      providerId: cellInfo.providerId,
      providerIdTypeCd: cellInfo.providerIdTypeCd,
    };
    dispatch(getProviderIdTypeDetails());
    dispatch(
      navigateToProvider(payload, () => {
        redirectURLLink(
          '/ProviderDetails',
          'Provider Details',
          history,
          dispatch
        );
      })
    );
  };

  // PDF header
  const firstInfo = `Plan Type: ${
    selectedPlanType === 'FD'
      ? 'Medicaid'
      : selectedPlanType === 'COMM'
      ? 'Commercial'
      : selectedPlanType === 'ST'
      ? 'State'
      : selectedPlanType === 'SUPP'
      ? 'Supplemental'
      : ''
  }`;
  const secondInfo = `Date Range: ${`${dateRange.fromDate} - ${dateRange.toDate}`}`;
  const thirdInfo = `${rebateProgramName}`;
  const fourthInfo = `Cleared Audit: ${claimAuditSelected}`;
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      {!fullScreenView && (
        <>
          <CustomSeparator
            parent1="State Reports"
            parent2="Display Institutional Claims Unit Type Discrepancy"
          />
          <div className="tab-body custom-search-dates">
            <div className="mui-custom-form input-md field-xl">
              <div className="row mb-3 mt-2">
                <div className="col-6">
                  <TextField
                    label="Plan Type :"
                    id="planType"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      selectedPlanType === 'FD'
                        ? 'Medicaid'
                        : selectedPlanType === 'COMM'
                        ? 'Commercial'
                        : selectedPlanType === 'ST'
                        ? 'State'
                        : selectedPlanType === 'SUPP'
                        ? 'Supplemental'
                        : ''
                    }
                    name="planType"
                    disabled
                  />
                </div>
                <div className="col-6">
                  <TextField
                    label="Rebate Program :"
                    id="rebateProgram"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={rebateProgramName}
                    name="rebateProgram"
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-6">
                  <TextField
                    label="Claim Category : "
                    id="claimCategory"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={claimCategorySelected}
                    name="claimCategory"
                    disabled
                  />
                </div>
                <div className="col-6">
                  <TextField
                    label="Date Range : "
                    id="adjustDate"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={`${dateRange.fromDate} - ${dateRange.toDate}`}
                    name="adjustmentType"
                    disabled
                  />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-6">
                  <TextField
                    label="Cleared Audit : "
                    id="clearedauditt"
                    fullWidth
                    placeholder=""
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={claimAuditSelected}
                    name="clearedAudit"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <TableGridWithFeatures
        rowData={resultList || []}
        columnDefs={InstitutionalTableHead}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        enterMovesDown
        showResetFilter={false}
        defaultCol={{
          wrapHeaderText: true,

          autoHeaderHeight: true,
        }}
        hideTotalCount={false}
        exportFile
        isScrollOn
        // defaultColWidth={200}
        fileName="InstitutionalClaims"
        reportName="Institutional Claim Unit Type Discrepancy Report"
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
        frameworkComponents={{
          ActionCellRender: (cellInfo) => {
            return (
              <div
                className="tdCell icon-btn-group d-flex"
                data-testid="action-column"
              >
                <Dropdown className="icon-dropdown-container">
                  <Dropdown.Toggle
                    className="icon-dropdown export_wrap"
                    aria-label="export"
                  >
                    <SVGComponent iconName="Icon-export1" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="export_dropdown">
                    <Dropdown.Item
                      role="button"
                      data-testid="onEditingStopped11"
                      onClick={() => goToProvider(cellInfo?.data)}
                    >
                      Go To Provider
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            );
          },
          TextBoxRender: (cellInfo) => {
            const name = cellInfo?.value;

            if (name && name.length > 20) {
              return (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                >
                  <div>{name}</div>
                </OverlayTrigger>
              );
            }
            return <div>{name}</div>;
          },
        }}
      />
    </div>
  );
}
